import React from 'react';
import { List, Icon, Tooltip } from 'antd';
import UserReportsListWrapper from './UserReportsList.style';

const UserReportsList = ({data,user,getConversationData,toggleConversationPopup,setConversationUser,getReportFiles,toggleAttachPopup,from}) => {
  return(
    <UserReportsListWrapper>
      <div className="flex section-header">
        <Tooltip message="Go Back" onClick={() => setConversationUser({ id: 0 })}>
          <Icon type="arrow-left" className="back-arrow-btn" />
        </Tooltip>
        <h2>Reports purchased by {user.name}</h2>
      </div>
      <List
        header={<div className="flex header-user-wrapper">
                  <p className="user-name">Report ID</p>
                  <p className="user-email-id">Report Name</p>
                </div>}
        dataSource={data}
        renderItem={(report,i) => (<List.Item key={i+1}>
          <div className="flex user-wrapper">
            <p className="user-name">{report.report_id}</p>
            <p className="user-email-id">{report.title}</p>
            <div className="user-actions">
              <Tooltip title={from === 'reports' ? 'Attach Reports' : "View Chat"}>
                <Icon type={from === 'reports' ? 'file-add' : 'message'} className="view-chat-icon" onClick={ (from === 'reports') ? () => {getReportFiles(report);toggleAttachPopup(true);} : () => {getConversationData(report,from);toggleConversationPopup(true); } } />
              </Tooltip>
            </div>
          </div>
          </List.Item>)}
        pagination={true}
      />
    </UserReportsListWrapper>
  )
}

export default UserReportsList;


// WEBPACK FOOTER //
// ./src/components/Box/UserReportsList/UserReportsList.js